import dispatchersModule from './dispatchers'
import financesModule from '@modules/finances'
import usersModule from './users'
import wholesalersModule from './wholesalers'

const addModule = ({ meta: module, routes }) => {
  return routes.map(({ name, path, exact, component, meta }) => ({
    path,
    name,
    exact,
    component,
    meta: { ...meta, module }
  }))
}

export const routes = [
  ...addModule(usersModule),
  ...addModule(dispatchersModule),
  ...addModule(wholesalersModule),
  ...addModule(financesModule)
]

export const meta = {
  wholesalers: wholesalersModule.meta,
  dispatchers: dispatchersModule.meta,
  finances: financesModule.meta,
  users: usersModule.meta
}
